export default {
    topics: [
        {
            title: ' Cancel ',
            href: 'sm-localOrder-Cancel.html',
            attributes: { 'data-id': 'sm-localOrder-Cancel' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-Cancel-d66e3069',
            topics: [],
        },
        {
            title: ' CreateFromCatalog ',
            href: 'sm-localOrder-CreateFromCatalog.html',
            attributes: { 'data-id': 'sm-localOrder-CreateFromCatalog' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-CreateFromCatalog-d66e3077',
            topics: [],
        },
        {
            title: ' EvaluateContent ',
            href: 'sm-localOrder-EvaluateContent.html',
            attributes: { 'data-id': 'sm-localOrder-EvaluateContent' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-EvaluateContent-d66e3085',
            topics: [],
        },
        {
            title: ' EvaluateContentFromId ',
            href: 'sm-localOrder-EvaluateContentFromId.html',
            attributes: { 'data-id': 'sm-localOrder-EvaluateContentFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-EvaluateContentFromId-d66e3093',
            topics: [],
        },
        {
            title: ' EvaluateDeliveryBudget ',
            href: 'sm-localOrder-EvaluateDeliveryBudget.html',
            attributes: { 'data-id': 'sm-localOrder-EvaluateDeliveryBudget' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-EvaluateDeliveryBudget-d66e3101',
            topics: [],
        },
        {
            title: ' EvaluateTarget ',
            href: 'sm-localOrder-EvaluateTarget.html',
            attributes: { 'data-id': 'sm-localOrder-EvaluateTarget' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-EvaluateTarget-d66e3109',
            topics: [],
        },
        {
            title: ' EvaluateTargetFromId ',
            href: 'sm-localOrder-EvaluateTargetFromId.html',
            attributes: { 'data-id': 'sm-localOrder-EvaluateTargetFromId' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-EvaluateTargetFromId-d66e3117',
            topics: [],
        },
        {
            title: ' ExecuteTarget ',
            href: 'sm-localOrder-ExecuteTarget.html',
            attributes: { 'data-id': 'sm-localOrder-ExecuteTarget' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-ExecuteTarget-d66e3125',
            topics: [],
        },
        {
            title: ' Reserve ',
            href: 'sm-localOrder-Reserve.html',
            attributes: { 'data-id': 'sm-localOrder-Reserve' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-Reserve-d66e3133',
            topics: [],
        },
        {
            title: ' Validation ',
            href: 'sm-localOrder-Validation.html',
            attributes: { 'data-id': 'sm-localOrder-Validation' },
            menu: { hasChildren: false },
            tocID: 'sm-localOrder-Validation-d66e3141',
            topics: [],
        },
    ],
};

